import React, { useState } from "react";
import { Pressable, Text, Image, StyleSheet } from "react-native";

const SR_LOGO = require("../../assets/sr-blk-logo-1.png");

/** Map top bar — SpeedRailz (opens SpeedRailz sheet). */
export default function MapSpeedRailzButton({ onPress }) {
  const [pressed, setPressed] = useState(false);

  return (
    <Pressable
      onPress={onPress}
      onPressIn={() => setPressed(true)}
      onPressOut={() => setPressed(false)}
      accessibilityRole="button"
      accessibilityLabel="SpeedRailz"
      style={[styles.button, pressed && styles.buttonPressed]}
    >
      <Image source={SR_LOGO} style={styles.logo} resizeMode="contain" />
      <Text style={styles.label}>Speedrailz</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: 44,
    paddingHorizontal: 10,
    backgroundColor: "#FDE047",
    borderWidth: 2,
    borderColor: "#FACC15",
    borderRadius: 999,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
    elevation: 4,
  },
  buttonPressed: {
    backgroundColor: "#FACC15",
    borderColor: "#EAB308",
  },
  logo: {
    width: 20,
    height: 20,
  },
  label: {
    marginLeft: 6,
    fontSize: 14,
    lineHeight: 20,
    fontWeight: "700",
    color: "#000000",
    fontFamily: "AbhayaLibre_700Bold, serif",
  },
});
